import { Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { GifPreview, Kudos, LinkPreview } from "@teammood/timeline";

import { KudosRecipientsDisplayComponent } from "../../kudos-recipients-display.component";
import { LinkyModule } from "@teammood/shared/util/linky";
import { AnonymityPreviewComponent } from "../../../../timeline-item-creation-dialog/anonymity-preview/anonymity-preview.component";
import { PublicationPreviewComponent } from "../../../../timeline-item-creation-dialog/publication-preview/publication-preview.component";
import { NotificationPreviewComponent } from "../../../../timeline-item-creation-dialog/notification-preview/notification-preview.component";
import { GifPreviewComponent } from "../../../../../shared/ui/gifpreview/gifpreview";
import { UserInfos } from "../../../../../shared/ui/username-icon/user-infos.type";
import { MoodsService } from "../../../moods/moods.service";
import { FormControl } from "@angular/forms";


@Component({
    selector: 'kudos-preview',
    templateUrl: 'kudos-preview.component.html',
    styleUrls: ['./kudos-preview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    TranslateModule,
    KudosRecipientsDisplayComponent,
    GifPreviewComponent,
    LinkyModule,
    AnonymityPreviewComponent,
    PublicationPreviewComponent,
    NotificationPreviewComponent
]
})
export class KudosPreviewComponent implements OnChanges{

    protected kudosMessageCtrl = new FormControl<string>('');
    protected gifPreviews: GifPreview[] = [];

    @Input() kudos: Kudos;
    @Input() userInfos: UserInfos;
    @Input() state: string; 
    @Input() message: string;
  
    constructor(
        private moodsService: MoodsService
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if(changes){
            this.get_link_previews();
        }
    }

    async get_link_previews () {
        if (this.kudos &&  this.kudos.message) {
            const previews : LinkPreview[] = (await this.moodsService.getCommentLinkPreviews(this.kudos.message.body));
            this.gifPreviews = previews.filter(preview => preview.url.slice(-4) === '.gif').map(preview => new GifPreview(preview));
        } else {
             this.gifPreviews = [];
        }
    };

}